import { render, staticRenderFns } from "./AprobarPlanIns.vue?vue&type=template&id=41e6dbca&scoped=true"
import script from "./AprobarPlanIns.vue?vue&type=script&lang=js"
export * from "./AprobarPlanIns.vue?vue&type=script&lang=js"
import style0 from "./AprobarPlanIns.vue?vue&type=style&index=0&id=41e6dbca&prod&scoped=true&lang=css"
import style1 from "./AprobarPlanIns.vue?vue&type=style&index=1&id=41e6dbca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e6dbca",
  null
  
)

export default component.exports